import api from "@/lib/apiClient";

/**
 * USAGE-ANALYTICS-1 / C-322 — the two usage routes this lane talks to.
 *
 * Both shapes are taken from #717's own router rather than assumed:
 *
 *   POST /api/usage/events      -> 202 ALWAYS. The body is identical whether a row was written or
 *                                 not, deliberately: "a client that learns 'not stored' has
 *                                 learned the gate's answer and can act on it, and a client acting
 *                                 on the gate's answer is the client deciding." So nothing here
 *                                 reads the response.
 *   GET  /api/usage/preference  -> { enabled, consent_required }, both SERVER-DERIVED. This is the
 *                                 designated read — "what the one Settings control should show
 *                                 (C-161), derived server-side" — and C-323 §4 makes it the gate
 *                                 the caller consults before sending anything.
 *
 * ⚑ The PUT takes one boolean and nothing else (`extra="forbid"`), and it CANNOT grant where
 * consent is required: ON in a consent-required region answers 409, because granting needs a
 * document id and a sha and "a boolean has neither". OFF the server does alone.
 */
export const usageApi = {
  postEvent: (payload) => api.post("/api/usage/events", payload),
  preference: () => api.get("/api/usage/preference"),
  setPreference: (enabled) => api.put("/api/usage/preference", { enabled }),
};

export default usageApi;
